


























import { computed, defineComponent } from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';

import getDataForGroupAddress from '@/gql/thaiLocation/getDataForGroupAddress.gql';

import CommonProvinceSelector from '@/components/LocationAddress/CommonProvinceSelector.vue';
import CommonDistrictSelector from '@/components/LocationAddress/CommonDistrictSelector.vue';

const ProvinceAndDistrictSelector = defineComponent({
  components: {
    CommonProvinceSelector,
    CommonDistrictSelector,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        id: -1,
        province: {
          id: '',
        },
        district: {
          id: '',
        },
      }),
    },
    rules: { default: '' },
    hideDelete: { default: false },
  },
  setup(props, { emit }) {
    const { result: getDataForGroupAddressQuery, loading: districtLoading } = useQuery(getDataForGroupAddress, {
      fetchPolicy: 'cache-and-network',
    });
    const provinces = useResult(getDataForGroupAddressQuery, [], (data) => data.provinces);
    const districts = computed(() => {
      if (!props.value.province.id) return [];
      const filteredProvince = provinces.value.find((province: any) => String(province.id) === String(props.value.province.id));
      if (filteredProvince && filteredProvince.districts) return filteredProvince.districts;
      return [];
    });
    function onUpdate(type: string, newValue: string) {
      if (type === 'province') {
        emit('input', {
          id: props.value.id,
          province: { id: newValue },
          district: { id: '' },
        });
      } else if (type === 'district') {
        emit('input', {
          id: props.value.id,
          province: props.value.province,
          district: { id: newValue },
        });
      }
    }

    return {
      provinces,
      districts,
      onUpdate,
    };
  },
});

export default ProvinceAndDistrictSelector;
